import { render, staticRenderFns } from "./index.vue?vue&type=template&id=632baffe&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=632baffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632baffe",
  null
  
)

export default component.exports